import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import AiFields from "../components/AIFields";
import { useTranslation } from 'react-i18next';

function GeneralizedLowRank({
    action,
    variables,
    setOpenVariable,
    automId,
}) {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();
    return (
        <div>
            <div className="form-element">
                <Button onClick={() => setOpen(true)} style={{
                    background: "#031226",
                    borderRadius: "2px",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: 700,
                    textTransform: "none"
                }}>
                    {t('CONTENT.CONFIGURATION-FORM.AI.CONFIGURE')}
                </Button>
            </div>
            {open && (
                <AiFields
                    data={[
                        "model_id",
                        "training_frame",
                        "validation_frame",
                        "ignore_const_cols",
                        "representation_name",
                        "loading_name",
                        "transform",
                        "k*",
                        "loss",
                        "loss_by_col",
                        "loss_by_col_idx",
                        "multi_loss",
                        "period",
                        "regularization_x",
                        "regularization_y",
                        "gamma_x",
                        "gamma_y",
                        "max_iterations",
                        "max_updates",
                        "init_step_size",
                        "min_step_size",
                        "seed",
                        "init",
                        "svd_method",
                        "user_y",
                        "user_x",
                        "expand_user_y",
                        "impute_original",
                        "recover_svd"
                    ]}
                    setOpen={setOpen}
                    action={action}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    automId={automId}
                />
            )}
        </div>
    );
}

export default GeneralizedLowRank;